import deTranslation from './assets/locales/localizedLabels_GMG-Env_Admin_de.json';
import enTranslation from './assets/locales/localizedLabels_GMG-Env_Admin_en.json';

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
// import { i18nextPlugin } from 'translation-check';

export const resources = {
    de: { translation: deTranslation },
    en: { translation: enTranslation },
};

void i18n
    .use(initReactI18next)
    // You can comment in (and install) the i18nextPlugin to check the localization status locally.
    // It should not be deployed like that to avoid an unnecessary dependency.
    // .use(i18nextPlugin)
    .init({
        debug: false,
        lng: 'en',
        fallbackLng: 'en',
        ns: 'translation',
        resources: resources,
        interpolation: {
            escapeValue: false, // react already safes from xss
        },
    });

export default i18n;